<template>
  <div class="common-bar" v-if="isVisible" @click="customHandler">
    <i class="iconfont c-006AFE font-30" v-html="icon"> </i>
    <div class="bar-content font-30">
      <slot> 本学期已结束，请到「学期时间」中维护下学期的起止日期 </slot>
    </div>
    <i
      v-if="showClose"
      class="iconfont c-171A1D-24 font-30"
      @click="closeHandler"
      >&#xe717;</i
    >
  </div>
</template>

<script>
export default {
  name: 'commonBar',
  components: {},
  props: {
    icon: {
      type: String,
      default: '&#xe728;'
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: true
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    closeHandler() {
      this.isVisible = false
      this.$emit('close')
    },
    customHandler() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-bar {
  background: rgba($color: #006afe, $alpha: 0.12);
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: normal;
  display: flex;
  align-items: center; /* 垂直居中 */
  min-height: 60px;
  margin-bottom: 2px;
  .bar-content {
    line-height: normal;
    margin-left: 8px;
    font-weight: 400;
    text-align: left;
    color: #006afe;
    margin-right: 9px;
    flex: 1;
  }
}
</style>
